import AnimationModal from './animation-modal';
export default AnimationModal;
